<template>
  <div>
    <v-divider></v-divider>
    <v-data-table
      class='my-table'
      :loading='isLoading'
      :items='items'
      :headers='headers'
      :search='search'
      :items-per-page='-1'
      disable-sort
      dense
      hide-default-footer
      hide-default-header
      :no-data-text='noDataText'
    >
      <template v-slot:item.project='{ item }' class='mx-0 px-0'>
        <project-tile
          :project='item'
          :isLoading='isLoading'
          :areProjectsSelected='areProjectsSelected'
          @clicked='clicked'
          @insertBefore='insertBefore'
          @update='update'
          @openCrewVisits='openCrewVisits'
          @openQuickView='openQuickView'
          @getLatLng='getLatLng'
        ></project-tile>
      </template>
      <template v-slot:item.name='{ item }'>
        <span v-show='false'>{{item}}</span>
      </template>
      <template v-slot:item.site_address='{ item }'>
        <span v-show='false'>{{item}}</span>
      </template>
      <template v-slot:item.site_city='{ item }'>
        <span v-show='false'>{{item}}</span>
      </template>
    </v-data-table>
    
  </div>
</template>

<script>
import ProjectTile from './ProjectTile';

export default {
  name: 'project-list',
  props: {
    items: {
      required: true
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    areProjectsSelected: {
      required: true
    },
    search: {
      required: false
    },
    noDataText: {
      required: false,
      type: String,
      default: "No Routed Projects"
    }
  },
  data: () => ({
    headers: [
      { text: '', value: 'project' },
      { text: '', value: 'name'},
      { text: '', value: 'site_address'},
      { text: '', value: 'site_city'}
    ]
  }),
  methods: {
    clicked (proj) {
      this.$emit('clicked', proj)
    },
    insertBefore (proj) {
      this.$emit('insertBefore', proj)
    },
    update (proj) {
      this.$emit('update', proj)
    },
    openCrewVisits (proj) {
      this.$emit('openCrewVisits', proj)
    },
    openQuickView (proj) {
      this.$emit('openQuickView', proj)
    },
    getLatLng (proj) {
      this.$emit('getLatLng', proj)
    }
  },
  components: {
    'project-tile': ProjectTile
  }
}
</script>

<style>
.my-table td {
  padding: 0px !important;
}

</style>